import React from 'react';
import styled from 'styled-components';
import IcoComment from '../../assets/images/board/ico-comment.svg';
import Input from '../atoms/Input';
import Button from '../atoms/Button';
import { nameMasking } from '../../util/scripts';

const CommentSt = {
  Wrap: styled.div`
    margin-bottom: 16px;
  `,
  List: styled.ul`
    margin-bottom: 16px;
  `,
  Item: styled.li`
    display: flex;
    align-items: flex-start;
    &:before {
      content: '';
      width: 14px;
      height: 34px;
      margin-right: 10px;
      background: url(${IcoComment}) no-repeat center;
    }
    &:not(:last-child) {
      margin-bottom: 6px;
    }
  `,
  Box: styled.div`
    flex: 1;
    border-radius: 8px;
    background: #f7f7f7;
  `,
  Inner: styled.div`
    padding: 16px 16px 7px;
  `,
  Row: styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 12px;
  `,
  User: styled.strong`
    color: #53575a;
    font-size: 14px;
    font-weight: 600;
  `,
  Remove: styled.button`
    color: #a56a58;
    font-size: 14px;
    font-weight: 500;
    text-decoration: underline;
  `,
  Comment: styled.p`
    color: #091219;
    font-size: 14px;
    font-weight: 500;
    line-height: 21px;
    word-break: keep-all;
  `,
  AddRow: styled.div`
    display: flex;
    justify-content: space-between;
  `,
  CommentMsg: styled.p`
    text-align: center;
    color: #7c868f;
    font-size: 16px;
    font-weight: 500;
  `,
};

const Comment = ({ datas, onDelete, onChange, onAddComment }) => {
  const memberId = sessionStorage.getItem('memberId')!;
  return (
    <CommentSt.Wrap>
      <CommentSt.List>
        {datas.map((i) => {
          return (
            <CommentSt.Item key={i.commentId}>
              <CommentSt.Box>
                <CommentSt.Inner>
                  <CommentSt.Row>
                    <CommentSt.User>{nameMasking(i.name)}</CommentSt.User>
                    {memberId === i.memberId && (
                      <CommentSt.Remove type={'button'} onClick={() => onDelete(i.commentId)}>
                        삭제
                      </CommentSt.Remove>
                    )}
                  </CommentSt.Row>
                  <CommentSt.Comment>{i.comment}</CommentSt.Comment>
                </CommentSt.Inner>
              </CommentSt.Box>
            </CommentSt.Item>
          );
        })}
      </CommentSt.List>
      {!!memberId ? (
        <CommentSt.AddRow>
          <Input width={'calc(100% - 106px)'} height={44} onChange={onChange} />
          <Button text={'등록'} width={98} height={44} $colorType={'peacock'} onClick={onAddComment} />
        </CommentSt.AddRow>
      ) : (
        <CommentSt.CommentMsg>로그인 후 댓글 작성이 가능합니다.</CommentSt.CommentMsg>
      )}
    </CommentSt.Wrap>
  );
};

export default Comment;
